<nav id="layout-navbar" class="navbar navbar-expand-md navbar-dark bg-body-tertiary">
	<div class="container-fluid p-0">

		<h1 class="ms-2 me-4 my-1 text-body" style="font-family:'Barlow Condensed'; font-weight:400; font-size:32.5px;"><span class="material-icons-outlined me-2" style="font-size:36px; vertical-align:text-bottom;">cloud</span>Central</h1>

        <% if (Anvil.session.user_auth) { %>
        <div class="text-end position-relative d-md-none" style="flex-grow:1; height:50px;">
            <ul class="navbar-nav ml-auto position-absolute" style="right:8px; top:0;">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle me-2" href="#" id="authDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-user ms-0 ms-md-2 me-2"></i> <%- Anvil.session.user.account_name %></a>
                    <div class="dropdown-menu dropdown-menu-end" style="right:1px;">
                        <a class="dropdown-item disabled" href="anvil://auth/page_profile"><i class="fa fa-user-cog"></i>Profil</a>
                        <div class="dropdown-divider"></div>
                        <button type="button" class="dropdown-item" onclick="Anvil.exec('auth/action_logout')"><i class="fa fa-sign-out-alt me-2"></i>Kijelentkezés</button>
                    </div>
                </li>
            </ul>
        </div>

        <button class="navbar-toggler me-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent">
			<span class="navbar-toggler-icon"></span>
        </button>
		<% } %>

        <% if (Anvil.session.user_auth) { %>
		<div class="collapse navbar-collapse p-2 p-md-0 mt-1 mt-md-0" id="navbarContent">
			<ul class="navbar-nav me-auto mb-2 mb-md-0">
				<li class="nav-item">
					<a class="nav-link" href="#"><i class="fa fa-home me-2 me-md-0"></i><span class="d-inline d-md-none">Kezdőlap</span></a>
				</li>
				<li class="nav-item dropdown">
					<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-building me-2"></i>Partnerek</a>
					<ul class="dropdown-menu">
						<li><a href="/company_group/list" class="dropdown-item"><i class="fa fa-fw fa-city me-2"></i>Cégcsoportok</a></li>
						<div class="dropdown-divider"></div>
						<li><a href="/company/list" class="dropdown-item"><i class="fa fa-fw fa-building me-2"></i>Cégek</a></li>
						<li><a href="/company_tag/list" class="dropdown-item"><i class="fa fa-fw fa-tag me-2"></i>Címkék</a></li>
						<div class="dropdown-divider"></div>
						<li><a href="/company/invoicing" class="dropdown-item"><i class="fa fa-fw fa-print me-2"></i>Számlázás</a></li>
						<li><a href="/transaction/list" class="dropdown-item"><i class="fas fa-fw fa-exchange-alt me-2"></i>Pénzmozgások</a></li>
					</ul>
				</li>
				<li class="nav-item dropdown">
					<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-clipboard me-2"></i>Termék menedzsment</a>
					<ul class="dropdown-menu">
						<li><a href="/c_order/company_db/list" class="dropdown-item"><i class="fa fa-fw fa-database me-2"></i>Adatbázisok</a></li>
						<div class="dropdown-divider"></div>

						<div class="row g-3" style="min-width:400px;">
							<div class="col">

								<!--<li><a href="/c_order/site/list" class="dropdown-item"><i class="fa fa-fw fa-store-alt me-2"></i>Telephelyek</a></li>-->
								<li><h6 class="dropdown-header">c-Order</h6></li>
								<li><a href="/c_order/terminal/list" class="dropdown-item"><i class="fa fa-fw fa-desktop me-2"></i>Terminálok</a></li>
								<!--<li><a href="/c_order/terminal/list_old" class="dropdown-item"><i class="fa fa-fw fa-desktop me-2"></i>Terminálok 2</a></li>-->
								<li><a href="/c_order/terminal/map" class="dropdown-item"><i class="fa fa-fw fa-map-marked-alt me-2"></i>Térkép</a></li>
								<li><a href="/c_order/company_db/product_audit" class="dropdown-item"><i class="fa fa-fw fa-boxes me-2"></i>Termék audit</a></li>
								<li><a href="/c_order/error_log/list" class="dropdown-item"><i class="fa fa-fw fa-wrench me-2"></i>Hibanapló</a></li>

								<div class="dropdown-divider"></div>

								<li><h6 class="dropdown-header">Pénztárgépek</h6></li>
								<li><a href="/c_order/aee/list" class="dropdown-item"><i class="fa fa-fw fa-cash-register me-2"></i>Lista</a></li>
								<li><a href="/c_order/aee/list?operator_service_id=145&sort_order=7a" class="dropdown-item"><i class="fa fa-fw fa-calendar-check me-2"></i>Felülvizsgálatok</a></li>

							</div>
							<div class="col" style="border-left:1px solid var(--bs-dropdown-divider-bg);">
								<!--<li><a href="/c_order/site/list" class="dropdown-item"><i class="fa fa-fw fa-store-alt me-2"></i>Telephelyek</a></li>-->

								<li><h6 class="dropdown-header">c-Store</h6></li>
								<li><a href="/c_store/c_store/list" class="dropdown-item"><i class="fa fa-fw fa-store-alt me-2"></i>Telephelyek / raktárak</a></li>

								<div class="dropdown-divider"></div>

								<li><h6 class="dropdown-header">HODOR</h6></li>
								<li><a href="/haccp/haccp/list" class="dropdown-item"><i class="fa fa-fw fa-store-alt me-2"></i>Telephelyek / raktárak</a></li>
								<li><a href="/haccp/haccp/device_list" class="dropdown-item"><i class="fa fa-fw fa-mobile-alt me-2"></i>Eszközök</a></li>
							</div>
						</div>
					</ul>
				</li>
				<li class="nav-item dropdown">
					<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-briefcase me-2"></i>Feladatok</a>
					<ul class="dropdown-menu">
						<li><a href="/issue/list?worker_user_id=<%- Anvil.session.user.id %>" class="dropdown-item"><i class="fa fa-fw fa-user me-2"></i>Saját munkalapok</a></li>
						<li><a href="/issue/list" class="dropdown-item"><i class="fa fa-fw fa-users me-2"></i>Minden munkalap</a></li>
					</ul>
				</li>
			</ul>

            <ul class="navbar-nav ml-auto position-absolute d-none d-md-flex" style="right:0; top:0;">
				<li class="nav-item">
					<a class="nav-link" href="#"><i class="fas fa-fw fa-adjust"></i></a>
				</li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle me-2" href="#" id="authDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-user ms-0 ms-md-2 me-2"></i> <%- Anvil.session.user.account_name %></a>
                    <div class="dropdown-menu dropdown-menu-end" style="right:1px;">
                        <a class="dropdown-item disabled" href="anvil://auth/page_profile"><i class="fa fa-user-cog"></i>Profil</a>
                        <div class="dropdown-divider"></div>
                        <button type="button" class="dropdown-item" onclick="Anvil.exec('auth/action_logout')"><i class="fa fa-sign-out-alt me-2"></i>Kijelentkezés</button>
                    </div>
                </li>
            </ul>
		</div>
        <% } %>

	</div>
</nav>

<script>
$(".dropdown").hover(
	function() {
		const $this = $(this)
		$this.addClass('show')
		$this.find('.dropdown-toggle').attr("aria-expanded", "true")
		$this.find('.dropdown-menu').addClass('show')
	},
	function() {
		const $this = $(this)
		$this.removeClass('show')
		$this.find('.dropdown-toggle').attr("aria-expanded", "false")
		$this.find('.dropdown-menu').removeClass('show')
	}
)
</script>
